export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getSocialMediaList: function getSocialMediaList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/social_media/get",
        method: "get",
        params: data
      });
    },
    addSocialMedia: function addSocialMedia() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/social_media/create",
        method: "post",
        data: data
      });
    },
    updateSocialMedia: function updateSocialMedia() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/social_media/update",
        method: "post",
        data: data
      });
    }
  };
});